import { Injectable, inject } from '@angular/core';
import { CmUiCompoundFilterObjectNameOption, PredefinedFilter } from '@cm/ui-modules';
import { TranslateElementsService } from './translate-elements.service';

@Injectable({
  providedIn: 'root',
})
export class FilterInitiatorService {
  private readonly translateElementsService = inject(TranslateElementsService);

  /**
   * Initializes filter translations for object names and predefined filters
   * This method can be called from any component constructor to translate filter fields
   *
   * @param objectNames - Array of compound filter object name options to translate
   * @param predefinedFilters - Array of predefined filters to translate
   */
  initializeFilterTranslations(
    objectNames?: CmUiCompoundFilterObjectNameOption[] | null,
    predefinedFilters?: PredefinedFilter[] | null,
  ): void {
    if (objectNames) this.translateElementsService.translateCompoundFilterObjectNames(objectNames);
    if (predefinedFilters)
      this.translateElementsService.translatePredefinedCompoundFilterObjectNames(predefinedFilters);
  }
}
